import { httpCreator } from "./httpCreator";

const BASE_URL = import.meta.env.REACT_APP_API_V2;

const httpClient2 = httpCreator(BASE_URL as string);

export { httpClient2 };
